import { render, staticRenderFns } from "./data23.vue?vue&type=template&id=321c7a7b&scoped=true"
import script from "./data23.vue?vue&type=script&lang=js"
export * from "./data23.vue?vue&type=script&lang=js"
import style1 from "./data23.vue?vue&type=style&index=1&id=321c7a7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c7a7b",
  null
  
)

export default component.exports